module.exports = __webpack_public_path__ + "static/media/ic_upload_green.15fdd295.svg";